import { useCallback, useContext, useEffect, useState } from "react";
import { getActBreakpoint } from "../src/lib/global";
import { CompareItemsContext, LocalizationContext } from "../src/lib/context";
import {
  collection,
  documentId,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import { db } from "../api_config/firebase-configuration";
import { NoCompareLayout } from "../src/components/Layout";
import Head from "next/head";
import CompareDesktop from "../src/components/Compare/CompareDesktop";
import CompareMobile from "../src/components/Compare/CompareMobile";
import { useScreenSize } from "../src/hooks/useScreenSize";
import { PlaceholderText } from "../src/components/Profile/PlaceholderText";

const compareHelperItems = {
  workAreaInfo: [
    {
      text: "Location",
      image: "locationIcon",
    },
    {
      text: "Free distance",
      image: "freeDistanceIcon",
      tooltip: "Distance from base location without charging extra expanses",
    },
    {
      text: "Max. distance",
      image: "maxDistanceIcon",
      tooltip:
        "Maximum distance from the base location where you can still take on projects competitively",
    },
  ],
  technicalInfo: [
    {
      text: "Certification",
      image: "certificateIcon",
      tooltip: "Certification tooltip",
    },
    {
      text: "Equipment",
      image: "equipmentIcon",
    },
    {
      text: "Software",
      image: "computerIcon",
    },
  ],
  reference: [
    {
      text: "Social",
      image: "socialSitesIcon",
    },
    {
      text: "References",
      image: "referenceIcon",
    },
  ],
};

export default function Compare() {
  const { comparePage, profilePage } =
    useContext(LocalizationContext).localeStrings;

  const { compareItems, setCompareItems } = useContext(CompareItemsContext);
  const [projects, setProjects] = useState(() => []);
  const [droners, setDroners] = useState<any>([]);
  const [dronersToCompare, setDronersToCompare] = useState([]);
  const smAndDown = useScreenSize("sm", "down");

  // // FETCH DRONERS' PROJECTS
  // useEffect(() => {
  //   dronersToCompare.map((droner) => {
  //     fetchProjects(droner?.uid).then((projects) =>
  //       setProjects((prevState) => [...prevState, projects])
  //     );
  //   });
  // }, [dronersToCompare]);

  const filterDroners = useCallback(() => {
    setDroners([]);
    const actBreakPoint = getActBreakpoint();
    const itemNum = actBreakPoint === "xs" || actBreakPoint === "sm" ? 2 : 5;

    for (let i = 0; i < itemNum; ++i) {
      if (compareItems[i]) {
        setDroners((arr: any) => [...arr, compareItems[i]]);
      }
    }
  }, [compareItems]);

  useEffect(() => {
    filterDroners();
  }, [compareItems, filterDroners]);

  useEffect(() => {
    setDroners(compareItems);
  }, [compareItems]);

  useEffect(() => {
    const getUsers = async () => {
      const url = new URL(window.location.href);
      const params = new URLSearchParams(url.search);
      localStorage.setItem(
        "compareArray",
        JSON.stringify(Array.from(params.values()))
      );
      if (compareItems.length !== 0) {
        const temp: any = [];
        const dronerSnap = await getDocs(
          query(
            collection(db, "usersPublic"),
            where(documentId(), "in", compareItems)
          )
        );
        dronerSnap.docs.forEach((doc) => {
          temp.push({ ...doc.data(), uid: doc.id });
        });
        setDronersToCompare(temp);
      } else {
        setDronersToCompare([]);
      }
    };
    getUsers().catch();
  }, [compareItems]);

  return (
    <div className="compare">
      <Head>
        <title>{comparePage.title}</title>
        <meta name="description" content={comparePage.description} />
      </Head>

      <div className="compare__main">
        <div className="compare__header">
          <h3 className="blue-small-text">Comparision</h3>
          <h2 className="blue-big-text">Compare drone pilots</h2>
        </div>

        {!smAndDown && (
          <CompareDesktop
            dronersToCompare={dronersToCompare}
            droners={droners}
            compareHelperItems={compareHelperItems}
            setCompareItems={setCompareItems}
            removeCompareUrlParameter={removeCompareUrlParameter}
            compareItems={compareItems}
          />
        )}

        {/* WILL BE DONE LATER */}
        {smAndDown && (
          <CompareMobile
            dronersToCompare={dronersToCompare}
            droners={droners}
            setCompareItems={setCompareItems}
            removeCompareUrlParameter={removeCompareUrlParameter}
            compareItems={compareItems}
            helperItems={compareHelperItems}
          />
        )}
      </div>

      <PlaceholderText
        title={comparePage.pageTitle}
        text={profilePage.placeholder}
      />
    </div>
  );
}

function removeCompareUrlParameter(paramVal: string) {
  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search);
  const newParams = new URLSearchParams();
  const paramsArray = Array.from(params.values());
  const paramKey = paramsArray.indexOf(paramVal);
  paramsArray.splice(paramKey, 1);
  for (let i = 0; i < paramsArray.length; i++) {
    newParams.append(i.toString(), paramsArray[i]);
  }
  url.search = newParams.toString();
  window.history.replaceState({ path: url.href }, "", url.href);
}

Compare.Layout = NoCompareLayout;
